import { render, staticRenderFns } from "./ManuscriptEditor.vue?vue&type=template&id=1f7899b0&scoped=true"
import script from "./ManuscriptEditor.vue?vue&type=script&lang=ts"
export * from "./ManuscriptEditor.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptEditor.vue?vue&type=style&index=0&id=1f7899b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7899b0",
  null
  
)

export default component.exports